// Generated from ContestRouteScore's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestRouteScoreCollectionFilterGroups
  = | {
    readonly participantAssignParticipant: Iri
  }
  | {
    readonly participantAssignRouteAssign: Iri | Iri[]
  }

export const contestRouteScoreCollectionFilterMapping: FilterDefinitionMapping<ContestRouteScoreCollectionFilterGroups> = {
  participantAssignParticipant: 'participantAssign.participant',
  participantAssignRouteAssign: 'participantAssign.routeAssign',
}

export type ContestRouteScoreCollectionSort = never
